export default __webpack_public_path__ + "static/HybridMobile-753e51a6a4dc0b073629c67fbe804503.png";